export default __webpack_public_path__ + "static/media/eventTrigger.7d109d34.svg";